/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrchestratorConfig } from './orchestratorConfig';
import { SubscriptionConfig } from './subscriptionConfig';
import { CloudProviderConfig } from './cloudProviderConfig';
import { InstallDbConfig } from './installDbConfig';
import { GcpDeploymentImageConfig } from './gcpDeploymentImageConfig';
import { UpgradeDeploymentInfo } from './upgradeDeploymentInfo';
import { AwsDeploymentImageConfig } from './awsDeploymentImageConfig';
import { DeploymentMigrationInfo } from './deploymentMigrationInfo';


export interface DeploymentConfig { 
    aws_initial_deployment_images?: AwsDeploymentImageConfig;
    cloud_provider?: CloudProviderConfig;
    gcp_initial_deployment_images?: GcpDeploymentImageConfig;
    installDb?: InstallDbConfig;
    migrationInfo?: DeploymentMigrationInfo;
    orchestrator?: OrchestratorConfig;
    subscription_info?: SubscriptionConfig;
    upgrade_deployment_info?: UpgradeDeploymentInfo;
}

